module.exports = __webpack_public_path__ + "media/images/emblems/Rivaz-coat_of_arms-1b23f7a572255f0fa391b585ceaec1dd.svg";